import request from '@/utils/request'


// 查询参数设置信息列表
export function listSetup(query) {
  return request({
    url: '/saifuneng/saifuneng-setup/list',
    method: 'get',
    params: query
  })
}

// 查询参数设置信息详细
export function getSetup(data) {
  return request({
    url: '/saifuneng/saifuneng-setup/detail',
    method: 'get',
    params: data
  })
}

// 修改参数设置信息
export function updateSetup(data) {
  return request({
    url: '/saifuneng/saifuneng-setup/edit',
    method: 'post',
    data: data
  })
}

// 新增参数设置信息
export function addSetup(data) {
  return request({
    url: '/saifuneng/saifuneng-setup/add',
    method: 'post',
    data: data
  })
}


